export default {
	entorno: state => {
		return state.entorno;
	}
};
